if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

var lastScrollTop = 0;
(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
    
     //animations below
     setTimeout(function(){
        if(document.getElementById('home')){
            document.getElementsByClassName('top-content-home__uvp')[0].classList.add('show-object');
        }
    }, 1000); 

	const animateHTML = function () {
        let elems,
            windowHeight;
        let init = function () {
            elems = document.getElementsByClassName('hide-object');
            windowHeight = window.innerHeight;
            addEventHandlers();
        };
        let addEventHandlers = function () {
            window.addEventListener('scroll', checkPosition);
            window.addEventListener('resize', init);
        };
        let checkPosition = function () {
            for (let i = 0; i < elems.length; i++) {
                let posFromTop = elems[i].getBoundingClientRect().top;
                if (posFromTop - windowHeight <= 0) {
                    elems[i].className = elems[i].className.replace('hide-object', 'show-object')
                }
            }
        };
        return {
            init: init
        }
    };
    animateHTML().init();

    /*** fancybox ***/
    $('.fancycopy-link').fancybox({
        //baseClass : 'fancycopy-popup',
        wrapCSS : 'fancycopy-popup',
        padding: 0,
        helpers: {
            overlay: {
              locked: false
            } 
        }
    });

    $('.fancyboxFloorplan').fancybox({
        //baseClass : 'fancy-floorplan',
        wrapCSS : 'fancy-floorplan',
        padding: 0,
        helpers: {
            overlay: {
                locked: false
            }
        }
    });

    /*** slick ***/
    // normal
    $('.sym-slides').not('.slick-initialized').slick({ 
        accessibility: true
    });  

    //slider with nav timer
    $('.slider-nav').not('.slick-initialized').slick({
        accessibility: true,
        pauseOnHover: false, 
        slidesToShow: 1,
        slidesToScroll: 1, 
        autoplay: false,
        //autoplaySpeed:5000,
        focusOnSelect: false,
        dots: true,
        fade: true,
        arrows: false,
        appendDots: $('.slider-dots-box'),
        dotsClass: 'slider-dots',
    });
    // On before slide change
    $('.slider-nav').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.slider-dots-box button').html('');
    }).trigger('beforeChange');
    // On before slide change
    $('.slider-nav').on('afterChange', function(event, slick, currentSlide) {
        $('.slider-dots-box button').each(function(index) {
            $(this).html('');
            $(this).attr('aria-label', 'Slide ' + (index + 1));
        });
        $('.slider-dots-box .slick-active button').html(`
            <svg class="progress-svg" width="40" height="40"> 
                <g transform="translate(19,19)">
                    <circle class="circle-go" r="18" cx="0" cy="0"></circle>
                </g> 
            </svg>`);
    }).trigger('afterChange'); 
    /*** end slick ***/

    // hide, show, or toggle
    const show = function (elem) {
        let getHeight = function () {
            elem.style.display = 'block';
            let height = elem.scrollHeight + 'px';
            elem.style.display = '';
            return height;
        };
        let height = getHeight(); // get element height
        elem.classList.add('appear');
        elem.style.height = height; // update the max-height
        window.setTimeout(function () {
            elem.style.height = '';
        }, 350);
    };
    const hide = function (elem) {
        elem.style.height = elem.scrollHeight + 'px';
        window.setTimeout(function () {
            elem.style.height = '0';
        }, 1);
        window.setTimeout(function () {
            elem.classList.remove('appear');
        }, 350);
    };
    const toggle = function (elem) {
        if (elem.classList.contains('appear')) {
            hide(elem);
            return;
        } else {
            show(elem);
        }
    };
    //toggle more details
    document.addEventListener('click', function (event) {
        if (!event.target.classList.contains('toggle-btn-js')) return;
        event.preventDefault();

        let content = document.querySelector(event.target.hash);

        if (event.target.classList.contains('active')) {
            event.target.classList.remove('active');
        } else {
            event.target.classList.add('active');
        }

        if (!content) return;
        toggle(content);

    }, false);

    if(window.location.hash){
        // smooth scroll to the anchor id
        $('html,body').animate({
            scrollTop:$(window.location.hash).offset().top - 50 + 'px'
        },1000,'swing');
    }

    /*** Function to modify form start planning label  ***/

    document.addEventListener('DOMContentLoaded', () => {
        const skipSelectors = [
            '.privary-navigation__item a',
            '.tertiary-navigation__item a',
            '.social-media a',
            '.form-planning label, .form-planning input, .form-planning select, .form-planning textarea',
            '.clearfix label a',
            '.form-module__submit .form-submit'
        ];
    
        skipSelectors.forEach(selector => {
            const elements = document.querySelectorAll(selector);
            if (elements.length > 0) {
                elements.forEach(element => {
                    element.setAttribute('tabindex', '-1');
                });
            }
        });
    });    

})();



function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
    
    if(document.documentElement.scrollTop > 20) {
		if(document.getElementById('home')){
			if(document.getElementById('header').classList.contains('down')){
				document.querySelector('.main-rfp__form').classList.add('hidden-form-home');
				setTimeout(function(){
					document.querySelector('.main-rfp__form--close-btn').style.display = "block";
				},500); 
			}
		}
	} else {
		if(document.getElementById('home')){
			document.querySelector('.main-rfp__form').classList.remove('hidden-form-home');
			setTimeout(function(){
				document.querySelector('.main-rfp__form--close-btn').style.display = "none";
			},100);
		}
	}

	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

    	//home animation
	var opacity = (document.body.offsetHeight - document.body.scrollTop) / document.body.offsetHeight;
    var scale = (document.body.offsetHeight - document.body.scrollTop) / document.body.offsetHeight;

    document.documentElement.style.setProperty('--headerOpacity', opacity);
    document.documentElement.style.setProperty('--headerScale', scale);  
}